import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectUser } from "../../../store/userSlice";
import SubHeader from "./SubHeader";
import logo_en from "../../../assets/images/logo_en.png";
import logo_ar from "../../../assets/images/logo_ar.png";
import style from "./index.module.css";
import { Menu } from "../../../components/Icons";
import { useCallback } from "react";
import { useTranslation } from "../../../hooks/useTranslation";
import MobileNav from "./MobileNav";
import DesktopHeader from "./desktopNav";

const Header = () => {
  const { user, siteLang } = useSelector(selectUser);
  const { locale } = useTranslation();

  const onExpandMobileNav = useCallback(() => {
    if (window.innerWidth <= 992) {
      const overlay = document.querySelector(`.${style.header__overlay}`);
      const nav = document.querySelector(`.${style.header__nav}`);
      if (nav?.classList?.contains(style[`header__nav--expanded`])) {
        nav.classList.remove(style[`header__nav--expanded`]);
        overlay?.classList?.remove(style[`header__overlay--visible`]);
      } else {
        nav?.classList?.add(style[`header__nav--expanded`]);
        overlay?.classList?.add(style[`header__overlay--visible`]);
      }
    }
  }, []);

  return (
    <header className="main_header">
      <div className={style.header}>
        <div className="container-lg">
          <div className={style.header__overlay} onClick={onExpandMobileNav}></div>
          <div className={style.header__content}>
            <div className={style.header__logo}>
              <Link to="/">
                <img src={siteLang === "ar" ? logo_ar : logo_en} alt={locale("romotors")} />
              </Link>
            </div>
            <button className={style.header__burger} onClick={onExpandMobileNav}>
              <Menu height="20" width="20" color="#2f2f2f" />
            </button>
            <nav className={style.header__nav}>
              <DesktopHeader />
              <MobileNav />
            </nav>
          </div>
        </div>
      </div>
      <SubHeader user={user} />
    </header>
  );
};

export default Header;
